import React, { useEffect, useLayoutEffect, useState } from 'react';
import Button from 'components/Button';
import Spin from 'antd/lib/spin';
import ModalCommon from 'components/Input/ModalCommon';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import dayjs from 'dayjs';
import { statusSchedules } from './AddMemberPopup';

export const paymentMethods = [
  { label: 'CREDIT_CARD', value: 'カード払い' },
  { label: 'BANK_TRANSFER', value: '銀行振込' },
  { label: 'PAYPAL', value: 'PayPal' },
  { label: 'UNDECIDED', value: '未定' },
];

export const textReceipt = [
  { label: 'SENT', value: '購入する' },
  { label: 'PURCHASE', value: '送付済み' },
];

export const receiptRecipient = [
  {
    value: 'REQUEST',
    label: '領収書の発行希望',
  },
  {
    value: 'ALREADY_ISSUED',
    label: '不要',
  },
];

const convertToMockData = (data) => {
  if (!data) return [];

  const result = [
    {
      label: '名前',
      value: data?.name || '',
    },
    {
      label: 'アルファベット名',
      value: data?.alphabeticalName || '',
    },
    {
      label: 'メールアドレス',
      value: data?.email || '',
    },
    {
      label: '連絡先',
      value: data.phoneInUser || '',
    },
    {
      label: '住所',
      html: `${data?.prefecturesInUser || ''}<br/>${data?.address || ''}`,
    },
  ];

  // Add schedule information if available
  if (data.schedule && data.schedule.length > 0) {
    const scheduleItems = [];

    scheduleItems.push({
      label: '開催月日',
      array: data.schedule.map((s) => ({
        label: '',
        value: `${dayjs(s.startTime).format('YYYY/MM/DD')} (${statusSchedules.find((sta) => sta.value === s.status).label})`,
      })),
    });

    scheduleItems.push({
      label: '開催場所',
      value: data?.courseSchedule.location,
    });

    scheduleItems.push({
      label: '担当講師',
      value: data.courseSchedule.instructor,
    });

    result.push({
      label: 'お申し込み日程',
      value: scheduleItems,
    });
  }

  // Add additional fields
  const additionalFields = [
    {
      label: '領収書の発行',
      value:
        receiptRecipient.find((item) => item.value === data.receiptRecipient)
          ?.label ||
        data.receiptRecipient ||
        '不要',
    },
    {
      label: '領収書の宛名・但書 ',
      value: data.receiptAddresseeNotes || '',
    },
  ];

  return [...result, ...additionalFields];
};

const InfoUserPopup = ({ isOpen, onCancel, infoId }) => {
  const [loading, setLoading] = useState(false);
  const [infoUser, setInfoUser] = useState(null);

  const getInfoUser = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getInfo(infoId)
      .then((res) => {
        setInfoUser(convertToMockData(res?.data));
      })
      .catch((err) => toast.error(err?.message || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    infoId && getInfoUser();
  }, [infoId]);

  useLayoutEffect(() => {
    if (!isOpen || loading) return;

    requestAnimationFrame(() => {
      const modalBody = document.querySelector('.ant-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    });
  }, [isOpen, loading]);

  return (
    <ModalCommon
      width={600}
      title={'情報'}
      open={isOpen}
      onCancel={onCancel}
      heightHeader={56}
      footer={
        <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
          <Button
            btnType="back"
            onClick={onCancel}
            fontSize={14}
            width={120}
            height={40}
            className="border border-[#E6EBF1] bg-transparent text-[#595959]"
          >
            閉じる
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div className="flex flex-col gap-5 text-[14px]">
          {infoUser?.map((item, index) => {
            // Skip separator items in the main loop
            if (item.label === '---' && item.value === '---') {
              return (
                <div
                  key={`sep-${index}`}
                  className="my-2 border-t border-gray-200"
                ></div>
              );
            }

            return (
              <div
                key={index}
                className={`flex ${Array.isArray(item.value) ? 'items-center' : 'items-center'} gap-[50px]`}
              >
                <div className="w-[140px]">{item.label}</div>
                <div className="flex-1">
                  {Array.isArray(item.value) ? (
                    <div className="flex flex-col justify-center space-y-2">
                      {item.value.map((subItem, subIndex) => {
                        return (
                          <div
                            key={subIndex}
                            className="flex items-start gap-2"
                          >
                            {subItem.label && (
                              <span className="w-max">{subItem.label} :</span>
                            )}
                            {subItem.value &&
                            typeof subItem.value === 'string' ? (
                              <span className="flex-1">
                                {subItem.value || ''}
                              </span>
                            ) : subItem.array &&
                              Array.isArray(subItem?.array) ? (
                              <div>
                                {subItem.array.map((item, index) => (
                                  <div key={index}>{item.value}</div>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  ) : item.value && typeof item.value === 'string' ? (
                    <span className="font-normal">{item.value || ''}</span>
                  ) : item.html ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: item.html }}
                      style={{ whiteSpace: 'pre-line' }}
                    ></div>
                  ) : item.array && Array.isArray(item.array) ? (
                    <div>
                      {item.array.map((item) => (
                        <div key={item.value}>{item.value}</div>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </Spin>
    </ModalCommon>
  );
};

export default InfoUserPopup;
